/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    no-loop-func
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import * as ProtocolUtil from 'notebook/protocols/ProtocolUtil';
// @ts-expect-error
import CommentBus from 'notebook/protocols/viewer/CommentBus';
import CommentForm from 'notebook/protocols/viewer/CommentForm';
import SingleComment from 'notebook/protocols/viewer/SingleComment';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const {SHOW_STATES} = CommentBus;

interface Props {
  linkableID?: number | string;
  linkType: string;
  onDescription: boolean;
  commentBus: CommentBus;
  commentReplies: Array<any>;
  comments: Array<any>;
}

type State = any;

export default class Commentable extends React.Component<Props, State> {
  static defaultProps = {onDescription: false};

  state: State = {
    active: false,
    showState: SHOW_STATES.HIDE,
  };

  commentsRef = React.createRef<HTMLDivElement>();

  checkActive = (newActive: any): void => {
    let active;
    if (newActive) {
      const {linkableID, linkType} = newActive;
      active = linkableID === this.props.linkableID && linkType === this.props.linkType;
      this.setState({active});
    } else {
      this.setState({active: false});
    }
  };

  getBounds = (): {bottom: number; top: number} => {
    const $node = $(ReactDOM.findDOMNode(this.commentsRef.current)!);
    const {top} = $node.offset()!;
    const bottom = $node.offset()!.top + $node.height();
    return {top, bottom};
  };

  reflow = (state: any): void => {
    this.setState({showState: state});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  prepareReport = (promises: any) => {
    const deferred = $.Deferred();
    this.setState({showState: SHOW_STATES.ALL});
    this.forceUpdate(() => deferred.resolve());
    return promises.push(deferred.promise());
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  report = (positions: any) =>
    positions.push(
      // eslint-disable-next-line no-restricted-syntax
      _.extend(this.getBounds(), {
        setState: this.reflow,
        linkableID: this.props.linkableID,
        linkType: this.props.linkType,
        skip: this.props.comments.length === 0 && !this.state.active,
      })
    );

  componentDidMount(): void {
    this.props.commentBus.on('activate', this.checkActive, this);
    this.props.commentBus.on('prepareReport', this.prepareReport, this);
    return this.props.commentBus.on('report', this.report, this);
  }

  componentWillUnmount(): void {
    return this.props.commentBus.off(null, null, this);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  toggleActive = () => {
    if (this.state.active) {
      return this.props.commentBus.clearActive();
    } else {
      return this.setActive();
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setActive = () =>
    this.props.commentBus.activate({
      linkableID: this.props.linkableID,
      linkType: this.props.linkType,
    });

  renderComments = (): React.ReactNode | null => {
    let comment: any;
    switch (this.state.showState) {
      case SHOW_STATES.ALL:
        return (() => {
          const result = [];
          for (comment of Array.from(_.sortBy(this.props.comments, (comment) => comment.created_at))) {
            result.push(
              <SingleComment
                // eslint-disable-next-line no-restricted-syntax
                {..._.extend({}, comment, {
                  key: comment.id,
                  // eslint-disable-next-line no-restricted-syntax
                  children: _.filter(this.props.commentReplies, (reply) => reply.item_id === comment.id),
                  commentBus: this.props.commentBus,
                  setActive: this.setActive,
                })}
              />
            );
          }
          return result;
        })();
      case SHOW_STATES.EXCERPT:
        comment = this.props.comments[0];
        return (
          <div className="comment-summary single-comment" onClick={this.toggleActive}>
            <span className="comment-author-name">{getPartyDisplayString(comment.creator)}</span>
            <span className="comment-body">{comment.text}</span>
          </div>
        );
      default:
        return null;
    }
  };

  render(): JSX.Element {
    const wrapperClassName = classNames('commentable-wrapper', {active: this.state.active});
    const addCommentIconClassName = classNames('add-comment-icon', {
      'force-show': this.props.comments.length > 0,
    });
    const showCreator = this.state.active && this.props.commentBus.canComment;
    const navID = ProtocolUtil.commentNavID(this.props.linkType, this.props.linkableID);
    return (
      <div id={navID} className={wrapperClassName}>
        <div className="cm-target">{this.props.children}</div>
        <div className="cm-comments hide-when-condensed">
          <div className="cm-gutter">
            {this.props.commentBus.canComment || this.props.comments.length > 0 ? (
              <a className={addCommentIconClassName} onClick={this.toggleActive}>
                <BenchlingIcon icon="comment" />
                <span className="comment-count">
                  {this.props.comments.length > 0 ? this.props.comments.length : '+'}
                </span>
              </a>
            ) : undefined}
          </div>
          <div className="cm-comments-wrapper">
            {this.state.showState === SHOW_STATES.HIDE ||
            (this.props.comments.length === 0 && !showCreator) ? (
              <div ref={this.commentsRef} />
            ) : (
              <div className="comment-group" ref={this.commentsRef}>
                {this.renderComments()}
                {(() => {
                  if (showCreator) {
                    return (
                      <CommentForm
                        linkableID={this.props.linkableID}
                        linkType={this.props.linkType}
                        onDescription={this.props.onDescription}
                        commentBus={this.props.commentBus}
                        shouldFocus={this.props.comments.length === 0}
                      />
                    );
                  } else if (
                    !this.state.active &&
                    this.props.commentBus.canComment &&
                    this.state.showState === SHOW_STATES.ALL
                  ) {
                    return (
                      <div className="comment-leave-msg" onClick={this.toggleActive}>
                        Leave a comment
                      </div>
                    );
                  }
                  return null;
                })()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
